import React, { FC } from 'react';

import { GetUserLeaderboardQueryVariables, useGetUserLeaderboardsQuery } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

import Widget from './Widget';

interface IProps {
  variables: GetUserLeaderboardQueryVariables;
}

const Query: FC<IProps> = ({ variables }) => {
  const notify = useNotify();

  const { data, isLoading } = useGetUserLeaderboardsQuery(null, {
    onError: notify.queryError,
  });
  if (isLoading) {
    return <Loaders.Widget />;
  }

  const { leaderboard_configs } = data.getLeaderboardForUser;
  if (leaderboard_configs?.length !== 0) {
    return <Widget configs={leaderboard_configs} variables={variables} />;
  }

  return null;
};

export default Query;
